import { useAuthenticator } from '@aws-amplify/ui-react';
import { Loading360 } from 'components/loading/Loading360';
import { useGlobalContext } from 'contexts/GlobalContext';
import { RequireAuth } from 'contexts/RequireAuth';
import AdminDashboard from 'layouts/adminEasy360';
import SystemOfflineNotice from 'pages/admin/erros/systemOfflineNotice';
import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import AdminLayout from './layouts/admin';
import AuthLayout from './layouts/auth';

// rotas autenticadas e rotas não autenticadas ou rota de autenticação (ex., na tela de login)

const AppRoutes: React.FC = () => {
	const { pathCompanyName, permissionsPage } = useGlobalContext();
	const location = useLocation();
	const { route } = useAuthenticator(context => [context.route]);

	const isPublicRoute =
		location.pathname.startsWith('/auth') ||
		location.pathname.startsWith('/offline');

	if (
		!isPublicRoute &&
		route === 'authenticated' &&
		(!pathCompanyName || Object.keys(permissionsPage).length === 0)
	) {
		return (
			<Loading360
				fullScreen
				size={300}
				variant='gradient'
				pulse={true}
			/>
		);
	}

	return (
		<Switch>
			<Route
				path={`/auth`}
				component={AuthLayout}
			/>
			<Route
				path={`/offline`}
				component={SystemOfflineNotice}
			/>
			{/* 🗝️ Componente abaixo responsável por bloquear o acesso a plataforma, deixar comentado para desenvolvimento e apenas descomentar se for utilizar autenticação */}
			<RequireAuth>
				{pathCompanyName && Object.keys(permissionsPage).length > 0 && (
					<Route
						path={`/${pathCompanyName}`}
						component={AdminLayout}
					/>
				)}
				<Route
					path={`/adminEasy360`}
					component={AdminDashboard}
				/>
			</RequireAuth>
		</Switch>
	);
};

export default AppRoutes;
